import { schema } from "normalizr";

export const activityTailSchema = new schema.Entity("activityTails", {});

export const activityTailsSchema = new schema.Array(activityTailSchema);
